module.exports = {"ru":{"modules":{"getwallet":{"title":"Добавить в Wallet"}}}}